module.exports = __webpack_public_path__ + "static/media/ZEEL.3d96f603.txt";